import { call, takeEvery } from "redux-saga/effects";
import { SAGA_ACTIONS } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";
import { APIS } from "../../_config";

export function* getMessageTemplate(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.TEMPLATE.GET_MESSAGE_TEMPLATE, action.payload || {}, true);
}

export function* insertUpdateMessageTemplate(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.TEMPLATE.INSERT_UPDATE_MESSAGE_TEMPLATE, action.payload, true);
}

export function* getEmailTemplate(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.TEMPLATE.GET_EMAIL_TEMPLATE, action.payload || {}, true);
}

export function* insertUpdateEmailTemplate(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.TEMPLATE.INSERT_UPDATE_EMAIL_TEMPLATE, action.payload, true);
}

export function* insertUpdateReceiptTemplate(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.RECEIPT_TEMPLATE.INSERT_UPDATE, action.payload, true);
}

export function* getReceiptTemplateDetails(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.RECEIPT_TEMPLATE.DETAILS_BY_ID, action.payload || {}, true);
}

export default function* templateSaga() {
    yield takeEvery(SAGA_ACTIONS.TEMPLATES.GET_MESSAGE_TEMPLATE, getMessageTemplate);
    yield takeEvery(SAGA_ACTIONS.TEMPLATES.INSERT_UPDATE_MESSAGE_TEMPLATE, insertUpdateMessageTemplate);
    yield takeEvery(SAGA_ACTIONS.TEMPLATES.GET_EMAIL_TEMPLATE, getEmailTemplate);
    yield takeEvery(SAGA_ACTIONS.TEMPLATES.INSERT_UPDATE_EMAIL_TEMPLATE, insertUpdateEmailTemplate);
    yield takeEvery(SAGA_ACTIONS.RECEIPT_TEMPLATE.INSERT_UPDATE, insertUpdateReceiptTemplate);
    yield takeEvery(SAGA_ACTIONS.RECEIPT_TEMPLATE.DETAILS_BY_ID, getReceiptTemplateDetails);
}